import { render, staticRenderFns } from "./PendencyApproval.vue?vue&type=template&id=f45be610"
import script from "./PendencyApproval.vue?vue&type=script&lang=js"
export * from "./PendencyApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports